import { useTheme } from '@simplywallst/ui-core';

export const MiniPriceChartDefinitions = () => {
  const theme = useTheme();
  return (
    <svg className="block size-0">
      <defs>
        <clipPath id="tooltip-arrow-clipping">
          <rect
            x="6"
            y="12"
            width="12"
            height="12"
            transform="rotate(45, 10, 10)"
          />
        </clipPath>
      </defs>
      <linearGradient id="positive-chart" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor={theme.color.good} stopOpacity="0.3" />
        <stop offset="90%" stopColor={theme.color.good} stopOpacity="0" />
      </linearGradient>
      <linearGradient id="negative-chart" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor={theme.color.bad} stopOpacity="0.3" />
        <stop offset="90%" stopColor={theme.color.bad} stopOpacity="0" />
      </linearGradient>
    </svg>
  );
};
